import { Injectable } from "@angular/core";
import { ThemeService } from "./theme.service";

@Injectable({ providedIn: 'root' })
export class ChartThemeService {
  constructor(private themeService: ThemeService) { }

  applyTheme(baseOptions: any = {}, isDark: boolean = this.themeService.getCurrentTheme()): any {
    const lightColors = ['#1E88E5', '#43A047', '#F4511E', '#FB8C00', '#8E24AA', '#3949AB'];
    const darkColors = ['#64B5F6', '#81C784', '#FFB74D', '#BA68C8', '#4DD0E1', '#E57373'];

    return {
      ...baseOptions,
      backgroundColor: isDark ? '#50575e' : '#ffffff',
      colors: isDark ? darkColors : lightColors,
      titleTextStyle: {
        color: isDark ? '#ffffff' : '#50575e',
        fontSize: 14,
        bold: true,
        ...(baseOptions.titleTextStyle || {})
      },
      legend: {
        ...(baseOptions.legend || {}),
        position: baseOptions.legend?.position || 'bottom',
        textStyle: {
          ...(baseOptions.legend?.textStyle || {}),
          color: isDark ? '#ffffff' : '#50575e',
          fontSize: 12
        }
      },
      hAxis: {
        ...(baseOptions.hAxis || {}),
        textStyle: {
          ...(baseOptions.hAxis?.textStyle || {}),
          color: isDark ? '#e0e0e0' : '#333'
        },
        titleTextStyle: {
          ...(baseOptions.hAxis?.titleTextStyle || {}),
          color: isDark ? '#ffffff' : '#50575e'
        },
        gridlines: { color: isDark ? '#333' : '#ccc' }
      },
      vAxis: {
        ...(baseOptions.vAxis || {}),
        textStyle: {
          ...(baseOptions.vAxis?.textStyle || {}),
          color: isDark ? '#e0e0e0' : '#333'
        },
        titleTextStyle: {
          ...(baseOptions.vAxis?.titleTextStyle || {}),
          color: isDark ? '#ffffff' : '#50575e'
        },
        gridlines: { color: isDark ? '#333' : '#ccc' }
      },
      chartArea: {
        backgroundColor: isDark ? '#50575e' : '#ffffff',
        ...(baseOptions.chartArea || {})
      },
      tooltip: {
        isHtml: isDark ? true : false, // allows dark/light control
        backgroundColor: isDark ? '#2c2c2c' : '#ffffff',
        textStyle: { color: isDark ? '#ffffff' : '#50575e', fontSize: 8 },
        showColorCode: true,
        focusTarget: 'category',
        ...(baseOptions.tooltip || {})
      }

    };
  }
}
